import axios from "axios";
import "./../assets/sass/style.css";
import { Link } from "react-router-dom";
import { IoIosAdd } from "react-icons/io";
import React, { useEffect, useState } from "react";
import { validateHeader, API_Link } from "../commons/Constants";
import { Loader2 } from "./webWorkers/LoaderFile/Loader";

function User() {
  // set useState
  const [isLoading, setIsLoading] = useState(false);
  const [userList, setUserList] = useState([]);
  const MD5hash = validateHeader();
  // get Token
  const user = JSON.parse(localStorage.getItem("user"));
  const token = user?.token;

  const getUserList = async () => {
    setIsLoading(true);
    await axios
      .get(`${API_Link}getUsers`, {
        headers: {
          "misr-auth": MD5hash,
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        setUserList(res.data.users);
        setIsLoading(false);
      });
    // .finally(() => setIsLoading(false));
  };

  // useEffect

  useEffect(() => {
    getUserList();
  }, []);

  return (
    <div className="main-wrapper">
      <div className="content-wrapper">
        <div className="page--content ">
          <div className="row sticky-title align-items-center">
            <div className="col-md-6 col-lg-6">
              <h1 className="page--heading ">User Listing</h1>
            </div>
            <div className="col-sm-6 col-xs-12 text--align--right ">
              {/* <a href="addreview" className="tem--add--btn"></a> */}
              <Link to="/admin/adduser" className="tem--add--btn">
                <IoIosAdd /> Add New User
              </Link>
            </div>
          </div>
          <div className="row">
            <div className="padding-table">
              <div className="table--template table-wrapper">
                <table className="table table-striped sticky-table">
                  <thead>
                    <tr>
                      <th>Sr.No</th>
                      <th>Name</th>
                      <th>Email</th>
                      <th>Department</th>
                      <th>Role</th>
                      <th>Status</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {!isLoading &&
                      userList &&
                      userList?.map((user, index) => (
                        <tr>
                          <td className="text-center">{index + 1} </td>
                          <td>{user.name}</td>
                          <td> {user.email}</td>
                          <td>
                            {user.department !== null
                              ? user.department.description
                              : ""}
                          </td>
                          <td>
                            {user.role !== null
                              ? user.role.role.charAt(0).toUpperCase() +
                                user.role.role.slice(1)
                              : ""}
                          </td>
                          <td>
                            {user.is_active === true ? (
                              <span className="text-success">Active</span>
                            ) : (
                              <span className="text-danger">Inactive</span>
                            )}
                          </td>
                          <td>
                            <Link
                              to={`/admin/edituser/${user.id}`}
                              className="tem--add--btn"
                            >
                              Edit
                            </Link>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
                {isLoading && (
                  <div className="user-listing-loader d-flex">
                    <Loader2 />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default User;
